import { Check } from "lucide-react";
import { Reveal } from "@/lib/motion";

const REASONS = [
  { t: "Budget Friendly", d: "Smart solutions designed around your budget." },
  { t: "Custom Designs", d: "Every design is tailored to your space." },
  { t: "Quality Materials", d: "Reliable materials and professional finishes." },
  { t: "Complete Execution", d: "From planning to installation — one team." },
  { t: "Transparent Quotes", d: "Clear scope, honest pricing, no surprises." },
  { t: "Working Since 2019", d: "Established renovation team serving Gurgaon." },
];

export const WhyChoose = () => (
  <section id="why" className="py-20 md:py-28 bg-white">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal><div className="overline text-ink-soft">Why Urban Renovations</div></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-tight">Honest work. Fair prices. Beautiful homes.</h2>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REASONS.map((r, i) => (
          <Reveal key={r.t} delay={(i % 3) * 0.05}>
            <div className="rounded-2xl border border-hairline bg-canvas p-6 hover:border-ink transition-colors">
              <span className="h-10 w-10 rounded-md bg-black text-white flex items-center justify-center"><Check className="h-5 w-5" /></span>
              <div className="mt-4 font-heading font-bold text-ink">{r.t}</div>
              <p className="mt-1.5 text-sm text-ink-soft leading-relaxed">{r.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
